import { Instance, types } from "mobx-state-tree";

export const CustomProjectPropertyValueModel = types.model({
  label: types.optional(types.string, ''),
  type: types.frozen(),
  value: types.frozen(),
  columnId: types.optional(types.number, 0),
  index: types.optional(types.number, 0),
});

export type CustomProjectPropertyValue = Instance<typeof CustomProjectPropertyValueModel>;
